import { render } from "./YardStatusLabel.vue?vue&type=template&id=8c45f61e&ts=true"
import script from "./YardStatusLabel.vue?vue&type=script&lang=ts"
export * from "./YardStatusLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__